import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {isNil, uniq} from 'ramda';

import {getCheckoutProfileErrors} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import type {ApiError} from 'shared/web';

import {getCheckoutProfileIssueMessage} from './getCheckoutProfileIssueMessage';

const getRefusalMessage = (code: string, fallback: string) =>
  match(code)
    .with('PROFILE_INCOMPLETE', () => i18n.t('entity.checkout.validation.activationIncomplete'))
    .otherwise(() => getCheckoutProfileIssueMessage(code, fallback));

// Grid actions have no form to place a refusal in, so each refused code gets its localized message
// in a toast. Any other failure keeps the generic API error handling.
export function handleCheckoutApiError(error: ApiError) {
  const refusal = getCheckoutProfileErrors(error);

  if (isNil(refusal)) {
    handleApiError(error);
    return;
  }

  uniq(refusal.errors.map((issue) => getRefusalMessage(issue.code, issue.message))).forEach(
    (message) => showNotification.error(message)
  );
}
